import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTurnoverHistory = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#E0BC00' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M17 24.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M14.008 18.882q.204.34.487.622a3.55 3.55 0 0 0 5.01 0 3.53 3.53 0 0 0 .99-2.002M13.505 16.499a3.5 3.5 0 0 1 .99-2.003 3.55 3.55 0 0 1 5.01 0c.195.195.353.405.488.622'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M13.865 20.885v-2.002h2.002M20.135 13.115v2.003h-2.003'
    />
  </svg>
);
export default SvgTurnoverHistory;
